import request from '@/utils/request';
//白名单列表
export function getQueryConsumeList(values) {
  return request('/coupon/queryConsumeList', {
    method: 'POST',
    data: values,
  });
}

//优惠券详情
export function getQueryGroupInfo(values) {
  return request('/profile/group/queryGroupInfo', {
    method: 'POST',
    data: values,
  });
}
//获取活动相关信息
export function getActivityInfo(values) {
  return request('/activityStaff/queryActivityDetail', {
    method: 'POST',
    data: values,
  });
}
//新建员工券活动
export function addActivityStaff(values) {
  return request('/activityStaff/addActivityStaff', {
    method: 'POST',
    data: values,
  });
}
//更新员工券活动
export function updateActivityStaff(values) {
  return request('/activityStaff/updateActivityStaff', {
    method: 'POST',
    data: values,
  });
}
